import type { AppMessages } from "@/i18n/ja";

export function renderTimPanel(
  container: HTMLElement,
  messages: AppMessages,
  options: {
    readonly isTouchPrimary: boolean;
    readonly isTimHovActivationUnlocked: boolean;
  },
): void {
  const description = document.createElement("p");
  description.className = "hover-idle-help-body";
  description.textContent = messages.help.tim.description;

  const timHovActivation = document.createElement("p");
  timHovActivation.className = "hover-idle-help-body";
  const activationMessages = messages.help.tim.timHovActivation;
  timHovActivation.textContent = options.isTimHovActivationUnlocked
    ? options.isTouchPrimary
      ? activationMessages.afterMobile
      : activationMessages.afterPc
    : options.isTouchPrimary
      ? activationMessages.beforeMobile
      : activationMessages.beforePc;

  const list = document.createElement("ul");
  list.className = "hover-idle-help-list";
  for (const item of messages.help.tim.items) {
    const listItem = document.createElement("li");
    listItem.textContent = item;
    list.append(listItem);
  }

  container.replaceChildren(description, timHovActivation, list);
}
